<template>
    <div style="display: contents" v-if="show">

        <div class="flex justify-end mt-4">
            <button-secondary @click="showModal = true"><template slot="icon"><i class="fa fa-repeat"></i></template> Vorschau anzeigen</button-secondary>
        </div>

        <portal to="modal" v-if="showModal">
            <modal @close="showModal = false">
                <template slot="header">Auslastung für die nächsten {{ caps.length }} Tage</template>

                <div class="border-t flex flex-wrap overflow-x-scroll">
                    <div class="flex-none w-16 mb-16" v-for="item in caps">
                        <div class="flex flex-col p-2">
                            <div class="border-b pb-2 text-center ">
                                <span class="font-bold">{{ item.date | weekday }}</span><br>
                                <span class="text-xs text-grey-700">{{ item.date | format }}</span>
                            </div>
                            <div class="pt-2 text-center" v-show="!item.isHoliday">
                                <span class="text-grey-900">{{ item.persons }}</span>
                                <span class=" text-grey-800"><i class="fa fa-user"></i></span>
                            </div>
                            <div class="text-center pt-2" v-show="!item.isHoliday">
                                <span class="text-grey-900">{{ item.free_desks }}</span>
                                <span class=" text-grey-800"><i class="fa fa-desktop"></i></span>
                            </div>
                        </div>
                    </div>
                </div>
            </modal>
        </portal>
    </div>
</template>

<script>
import Card from "./UI/Card";
import ButtonSecondary from "./UI/ButtonSecondary";
import Modal from "./Modal";

export default {
    name: "Capacity",

    components: {Modal, ButtonSecondary, Card},

    inject: ['group'],

    data: () => ({
        caps: [],
        intel: {},
        showModal: false,
        isLoading: true,
    }),

    created() {
        this.load();
    },

    filters: {
        weekday(date) {
            return ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'][new Date(date).getDay()];
        },
        format(date) {
            const foo = date.substring(5);

            return foo.substring(3) + '.' + foo.substring(0, 2) + '.';
        }
    },

    computed: {
        preview() {
            return this.caps.slice(0, 5);
        },
        show() {
            if (this.isLoading) {
                return false;
            }

            return this.group.allocation_mode === 'algorithm'
                || this.group.allocation_mode === 'group'
                || this.group.allocation_mode === 'group_fcfs';
        },
    },

    methods: {
        load() {
            window.axios.get('/admin/capacities').then(response => {
                this.caps = response.data.data;
                this.intel = response.data.intel;
                this.isLoading = false;
            });
        },
    },
}
</script>

<style scoped>

</style>
